import React, { Component } from 'react'
import './index.less'

export default class extends Component {
  render() {
    let { language, lang, funcTabBarRule, closeFuncTabBarRule } = this.props
    return (
      <div
        className={`lot-rule-wrap ${language == 'ar' && 'arlang'}`}
        style={{ display: funcTabBarRule == '1' ? 'block' : 'none' }}
      >
        <div className="lot-rule-box">
          <div className="close" onClick={() => { closeFuncTabBarRule() }}></div>
          <div className="lot-rule-title">{lang.rule}</div>
          <div className="lot-rule-content" dangerouslySetInnerHTML={{ __html: lang.ruleContent }}></div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/lottery/Rule/index.js